import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=321e1da0&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"
import style0 from "./EventList.vue?vue&type=style&index=0&id=321e1da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e1da0",
  null
  
)

export default component.exports